import { render } from "./WorksButton.vue?vue&type=template&id=2aa07362&scoped=true"
import script from "./WorksButton.vue?vue&type=script&lang=js"
export * from "./WorksButton.vue?vue&type=script&lang=js"

import "./WorksButton.vue?vue&type=style&index=0&id=2aa07362&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2aa07362"

export default script